<template>
  <div class="x-off-footer-box">
    <div class="x-off-footer">
      <!-- 左侧 -->
      <div class="x-off-fleft">
        <div class="x-off-fl-nav">
          <span>关于我们</span>
          <router-link to="/company">公司概述</router-link>
          <router-link to="/contactUs">联系我们</router-link>
          <router-link to="/news">新闻资讯</router-link>
        </div>
        <div class="x-off-fl-nav">
          <span>帮助中心</span>
          <router-link to="/help">帮助中心</router-link>
          <router-link to="/privacy">隐私政策</router-link>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="x-off-fright">
        <div class="x-off-fr-content">
          <div class="x-off-fr-nav">
            <span class="x-off-fr-nav-title">关于我们</span>
            <p style="margin-top: 13px;">
              <img src="@/assets/index/icon_location.png" alt="" />
             
              <span class="x-off-fr-nav-fu"> 河南省郑州市新郑市郭店镇新郑路与密杞路交叉口西北角五里口停车场院内A区1库1号</span>
            </p>
            <p style="align-items: center;"><img src="@/assets/index/icon_call.png" alt="" />4000077156</p>
          </div>
        </div>
        <div class="x-off-fr-img">
          <el-image
            style="width: 80px; height: 80px"
            :src="require('@/assets/common/wx.jpg')"
            fit="contain"
          ></el-image>
          <!-- <span>关注微信公众号</span> -->
        </div>
      </div>
    </div>
    <div class="x-off-shang">
      <span>Copyright © 2025 九驰供应链（河南）有限公司</span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index"> 豫ICP备2025120590号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.x-off-footer-box {
  background: #00aecf;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .x-off-footer {
    width: 1200px;
    flex: 1;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .x-off-fleft {
      width: 300px;
      height: 100%;
      flex-shrink: 0;
      display: flex;
      .x-off-fl-nav {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 18px;
        color: #fff;
        text-align: left;
        margin-top: 62px;
        span {
          line-height: 32px;
          margin: 20px 0 10px;
        }
        a {
          font-size: 16px;
          color: #fff;
          text-decoration: none;
          line-height: 30px;
          opacity: 0.8;
        }
      }
    }

    .x-off-fright {
      width: 500px;
      height: 100%;
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;
      .x-off-fr-nav {
        flex: 1;
        display: flex;
        flex-direction: column;
        color: #fff;
        text-align: left;
        
        .x-off-fr-nav-title {
          line-height: 32px;
          margin-top: 20px;
          font-weight: 500;
          font-size: 18px;
        }
        p {
          padding: 0;
          margin: 0 0 20px 0;
          display: flex;
          opacity: 0.8;
          img{
            width: 34px;
            height: 34px;
            margin-right: 10px;
          }
          .x-off-fr-nav-fu{
            font-size: 16px;
            line-height: 20px;
            color: #fff;
          }
        }
      }
      .x-off-fr-img {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-left: 20px;
        flex-shrink: 0;
        span {
          font-size: 16px;
          color: #fff;
          line-height: 20px;
        }

      }
    }
  }
  .x-off-shang {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #fff;
      font-size: 14px;
      opacity: 0.8;
      text-decoration: none;
      cursor: default;
      padding-right: 10px;
    }
    a {
      color: #fff;
      font-size: 14px;
      opacity: 0.8;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>
